import defaultSvgStorage from '#themes/default/default/components/svgStorage/svgStorage.js';

export default {
	extends: defaultSvgStorage
};
